import ApiService from '../service/ApiService';
import MethodService from '../service/MethodService';
import ApiServiceAxios from '../service/ApiServiceAxios';

let moduleApi = {};
let moduleName = "register_for_exam_config";
let token = MethodService.getToken();

moduleApi.create = (dataForm) => {
 let api = {
    module: moduleName,
    type: "create",
    value: dataForm,
    message: {
      error: "hidden"
    }
  };
  return ApiService(api);
};

moduleApi.update = (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm,
    message: {
      error: "hidden"
    }
  };
  return ApiService(api);
};

moduleApi.list = (dataFilter) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter
  };
  return ApiService(api);
};

moduleApi.delete = (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: {id: id}
  };
  return ApiService(api);
};

moduleApi.findById = (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: {id: id}
  };
  return ApiService(api);
};

moduleApi.GetProvincal = async () => {

  const body = {
      "ApiData": {
          "IS_ACTIVE": 1,
      }
  };

  const objJsonB64 = Buffer.from(JSON.stringify(body)).toString('base64');
  let api = {
      method: "GET",
      url:  window.MyConfig.urlProvince + "GetView?param=" + objJsonB64,
      headers: {
          'Content-Type': 'application/json',
      },
      message: {
          success: "",
          error: "",
      },
  };
  return ApiServiceAxios(api);
};

moduleApi.getHospital = async (provinceID, tokenTH) => {
  let tokenApi = tokenTH ? tokenTH : token;
  const body = {
      "ApiData": {
          "ORDER_FIELD": "MODIFY_TIME",
          "ORDER_DIRECTION": "DESC",
          "ID": null,
          "IS_ACTIVE": 1,
          "CREATE_TIME_FROM": null,
          "CREATE_TIME_TO": null,
          "MODIFY_TIME_FROM": null,
          "MODIFY_TIME_TO": null,
          "CREATOR": null,
          "MODIFIER": null,
          "GROUP_CODE": null,
          "KEY_WORD": "",
          "IDs": null,
          "PROVINCE_CODE_EXTRACT": provinceID ? provinceID : null
      }
  }
  const objJsonB64 = Buffer.from(JSON.stringify(body)).toString('base64');
  let api = {
      method: "GET",
      url: window.MyConfig.dkkUrl + "DkkHospital/Get?param=" + objJsonB64,
      headers: {
          ApplicationCode: window.MyConfig.applicationCode831,
          Accept: 'application/json',
          'Content-Type': 'application/json',
          TokenCode: tokenApi,
      },
      message: {
          success: "",
          error: "",
      },
  };
  return ApiServiceAxios(api);
}
export default moduleApi;
